<template>
  <resource-list-layout :resourceTitle="title">
    <template v-slot:filter>
      <intellectual-property-fitter :fitter="searchObj" @search="handleSearch" />
    </template>
    <resource-list-page-content :pageData="pageData" :cols="cols" v-loading="loading" @cell-click="handleCellClick" />
    <template v-slot:drawer>
      <risks-drawer :drawer="intellectualDrawer" :drawer-title="intellectualDrawerTitle" @handleClose="handleRisksClose" :company="company" />
      <company-info-drawer :drawer="companyInfoDrawer" :drawer-title="companyInfoDrawerTitle" @handleClose="handleCompanyInfoClose" :company-name="companyInfoId"/>
    </template>
  </resource-list-layout>
</template>

<script>
import ResourceListLayout from 'common/ResourceListLayout'
import ResourceListPageContent from 'common/ResourceListPageContent'
import PhoneInfo from "../company_risks/common/PhoneInfo.vue"
import UserOrder from "../company_risks/common/UserOrder.vue"
import CompanyInfoDrawer from "../company_risks/common/CompanyInfoDrawer"
import RisksDrawer from "../company_risks/common/RisksDrawer.vue"
import IntellectualPropertyFitter from "./common/IntellectualPropertyFitter"
import CompanyRisksFitter from "../company_risks/common/CompanyRisksFitter.vue";
export default {
  name: 'IntellectualProperty',
  components: {
    CompanyRisksFitter,
    ResourceListLayout,
    ResourceListPageContent,
    CompanyInfoDrawer,
    RisksDrawer,
    IntellectualPropertyFitter
  },
  provide () {
    return {
      pageOption: this.pageOption
    }
  },
  watch: {
    'pageOption.currentPage': {
      handler (newVal) {
        this.fetchData()
      }
    },
    'pageOption.pageSize': {
      handler (newVal) {
        this.fetchData()
      }
    }
  },
  computed: {
    searchStr: function () {
      let resultArray = Object.values(this.searchObj)
      let jsonStr = JSON.stringify(resultArray)

      return '&searchArr=' + jsonStr
    }
  },
  data () {
    return {
      title: '知识产权专题',
      searchObj: {
        select_key: '',
        company_name: { select_key: 'company_name', key: '', type: 'text', selectType: 'clue' },
        is_wechat: { select_key: 'is_wechat', key: '', type: 'is_or_null', selectType: 'clue' },
        phone: { select_key: 'phone', key: '', type: 'json_is_null', selectType: 'clue' },
        xlb_phone: { select_key: 'xlb_phone', key: '', type: 'json_is_null', selectType: 'clue' },
        self_phone: { select_key: 'self_phone', key: '', type: 'json_is_null', selectType: 'clue' },
        user_id: { select_key: 'user_id', key: '', type: 'is_null', selectType: 'clue' },
        order_id: { select_key: 'order_id', key: '', type: 'is_null', selectType: 'clue' },
        is_business: { select_key: 'is_business', key: '', type: 'is_or_null', selectType: 'clue' },
        trademark_name: { select_key: '商标名称', key: '', type: 'text', selectType: 'dimensionality' },
        trademark_status: { select_key: '商标状态', key: '', type: 'text', selectType: 'dimensionality' },
        trademark_type: { select_key: '国际分类', key: '', type: 'selectMultiple', selectType: 'dimensionality' },
        apply_for_date: { select_key: '申请日期', key: '', type: 'daterange', selectType: 'dimensionality' },
        bulletin_date: { select_key: '注册公告日期', key: '', type: 'daterange', selectType: 'dimensionality' },
        apply_for_num: { select_key: '申请号', key: '', type: 'text', selectType: 'dimensionality' },
        invented_name: { select_key: '发明名称', key: '', type: 'text_like', selectType: 'dimensionality' },
        patent: { select_key: '专利类型', key: '', type: 'selectMultiple', selectType: 'dimensionality' },
        law_status: { select_key: '法律状态', key: '', type: 'selectMultiple', selectType: 'dimensionality' },
        apply_for_day: { select_key: '申请日', key: '', type: 'daterange', selectType: 'dimensionality' },
        registration_no: { select_key: '登记号', key: '', type: 'text', selectType: 'dimensionality' },
        app_name: { select_key: '软件全称', key: '', type: 'text_like', selectType: 'dimensionality' },
        registration_date: { select_key: '登记日期', key: '', type: 'daterange', selectType: 'dimensionality' },
        acquisition_method: { select_key: '权利取得方式', key: '', type: 'selectMultiple', selectType: 'dimensionality' },
        record_number: { select_key: '公安备案号', key: '', type: 'text', selectType: 'dimensionality' },
        web_record_number: { select_key: '网站备案/许可证号', key: '', type: 'text', selectType: 'dimensionality' },
        domain: { select_key: '域名', key: '', type: 'text_like', selectType: 'dimensionality' },
        examined_date: { select_key: '审核日期', key: '', type: 'daterange', selectType: 'dimensionality' },
        web_types: { select_key: '网站类型', key: '', type: 'selectMultiple', selectType: 'dimensionality' },
        standard_no: { select_key: '标准号', key: '', type: 'text', selectType: 'dimensionality' },
        drafting_unit: { select_key: '起草单位', key: '', type: 'text_like', selectType: 'dimensionality' },
        release_date: { select_key: '发布日期', key: '', type: 'daterange', selectType: 'dimensionality' },
        standard_status: { select_key: '状态', key: '', type: 'selectMultiple', selectType: 'dimensionality' },
        register_status: { select_key: '登记状态', key: '', type: 'selectMultiple', selectType: 'dimensionality', is_base: 1 },
        create_year: { select_key: '成立日期', key: '', type: 'date_year', selectType: 'dimensionality', is_base: 1 },
        province: { select_key: '所属省份', key: '', type: 'selectMultiple', selectType: 'dimensionality', is_base: 1 },
        cities: { select_key: '所属城市', key: '', type: 'selectMultiple', selectType: 'dimensionality', is_base: 1 },
        region: { select_key: '所属区县', key: '', type: 'selectMultiple', selectType: 'dimensionality', is_base: 1 }
      },
      pageData: [],
      pageOption: {
        total: 0,
        currentPage: 1, // 当前页数
        pageSize: 30, // 每页显示条数
      },
      loading: false,
      cols: [
        { label: 'id', prop: 'id', fixed: true },
        { label: '企业名称', prop: 'company_name', clickable: true, fixed: true, width: '240' },
        { label: '企业状态', prop: 'basic_info.info.登记状态', width: '120' },
        { label: '商标信息', prop: '商标信息', clickable: true },
        { label: '专利信息', prop: '专利信息', clickable: true },
        { label: '软件著作权', prop: '软件著作权', width: '120', clickable: true },
        { label: '备案网站', prop: '备案网站', clickable: true },
        { label: '标准信息', prop: '标准信息', clickable: true },
        { label: '法人', prop: 'basic_info.info.法定代表人'},
        { label: '手机号', prop: 'phone', component: PhoneInfo, width: '205'},
        { label: '手机号（渠道拉取）', prop: 'xlb_phone', component: PhoneInfo, width: '205'},
        { label: '手机号（清洗后）', prop: 'self_phone', component: PhoneInfo, width: '205'},
        { label: '会员/订单', prop: '', width: '120', component: UserOrder}
      ],
      companyInfoId: '',
      companyInfoDrawerTitle: '企业信息',
      companyInfoDrawer: false,
      company: {},
      intellectualDrawerTitle: '',
      intellectualDrawer: false
    }
  },
  methods: {
    fetchData () {
      this.loading = true
      this.$axios.get('/api/admin/upload_tasks/intellectual_property?page=' + this.pageOption.currentPage + '&pageSize=' + this.pageOption.pageSize + this.searchStr, { loadingClose: true })
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.pageData = data.data.data
            this.pageOption.total = data.data.total
            this.loading = false
          }
        })
    },
    handleCellClick({ row, prop }) {
      if (prop === 'company_name') {
        this.companyInfoId = row.company_name
        this.companyInfoDrawer = true
        this.companyInfoDrawerTitle = row.company_name
      } else {
        this.getIntellectualInfo({ company_name: row.company_name, key: prop })
      }
    },
    getIntellectualInfo (company) {
      this.company = company
      this.intellectualDrawerTitle = company.company_name + '--' + company.key
      this.intellectualDrawer = true
    },
    handleCompanyInfoClose (drawer) {
      this.companyInfoDrawer = drawer
    },
    handleRisksClose (drawer) {
      this.intellectualDrawer = drawer
    },
    handleSearch (search) {
      this.resetCurrentPage()
    },
    resetCurrentPage () {
      if (this.pageOption.currentPage === 1) {
        this.fetchData()
        return
      }
      this.pageOption.currentPage = 1
    }
  },
  mounted () {
    this.fetchData()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/intellectual_property/IntellectualProperty.vue